import React, { useState } from 'react';
import { Play } from 'lucide-react';
import OptInModal from './OptInModal';

const WatchNowButton = ({ className = '' }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsModalOpen(true);
  };

  return (
    <>
      <button
        onClick={handleClick}
        className={`flex items-center justify-center gap-3 bg-[#cc0000] hover:bg-[#aa0000] text-white font-bold py-4 px-10 rounded-lg shadow-lg transform hover:scale-105 transition-all duration-300 text-xl mx-auto mt-4 ${className}`}
        aria-label="Watch video presentation"
      >
        <Play className="w-8 h-8" fill="white" />
        <span>Watch Now</span>
      </button>
      
      <OptInModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </>
  );
};

export default WatchNowButton;
